import { API_URL, getCredentials, buildHeadersWithSessionId } from "./Util";

// Cache of restaurant id => slug so we only fetch each slug once per session.
const slugCache = new Map<string, string>();

// Fetch the slug for a restaurant from the backend, caching the result.
// The slug is part of the restaurant's public info and is the single source
// of truth (previously hardcoded here).
export async function getRestaurantSlug(restaurantId: string): Promise<string> {
  const cached = slugCache.get(restaurantId);
  if (cached !== undefined) {
    return cached;
  }

  const res = await fetch(`${API_URL}/v1/public/r/${restaurantId}/info`, {
    credentials: "include",
    headers: buildHeadersWithSessionId({
      Authorization: `Basic ${getCredentials()}`,
    }),
  });
  if (!res.ok) {
    throw res;
  }

  const data: { slug: string } = await res.json();
  const slug = data.slug;
  slugCache.set(restaurantId, slug);
  return slug;
}
